/**
 * @file ResumeTeaserExtraInfoSlot.tsx
 *
 * @fileoverview This component renders additional things to the resume teaser section. This can be used to add extra
 * fields or any other relevant information on the resume search teasers.
 */

import { Slottable } from '~/jobiqo/components/Slots/interfaces';
import { Resume } from '~/jobiqo/types/types';

interface ResumeTeaserExtraInfoSlotProps {
  /**
   * The resume entity.
   */
  resume: Slottable<Resume>;
}

export default function ResumeTeaserExtraInfoSlot({
  resume,
}: ResumeTeaserExtraInfoSlotProps) {
  return null;
}
export { ResumeTeaserExtraInfoSlot };
